import { GridColDef } from "@mui/x-data-grid";
import DropdownList from "shared/components/DropdownList";
import { formatUpdatedAt } from "shared/utils/formatUpdatedAt";

export const getBrandSettingsColumns = (
  handleOpenSettingDetailPage: (settingId: string) => void,
): GridColDef[] => {
  return [
    {
      field: "title",
      headerName: "Search Settings",
      editable: false,
      flex: 1.5,
      sortable: false,
    },
    {
      field: "modulesCount",
      headerName: "Modules",
      editable: false,
      flex: 1,
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      editable: false,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => formatUpdatedAt(params.value),
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      editable: false,
      align: "right",
      headerAlign: "right",
      flex: 0.5,
      renderCell: (params) => (
        <DropdownList
          items={[
            {
              title: "Open",
              onClick: () => {
                handleOpenSettingDetailPage(params.row.id);
              },
            },
          ]}
        />
      ),
    },
  ];
};
